export const showUpdateAgencyToast = (agencyName: string) => {
  const toastMessage = 'Details for ' + agencyName + ' updated successfully';
  return toastMessage;
};

export const showAddAgencyToast = (agencyName: string) => {
  const toastMessage = `${agencyName} successfully added`;
  return toastMessage;
};
